import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import './styles.css';

const BusinessPlanSubSectionTitle = ({ label, label2 }) =>
	<div className="business-plan-sub-section-title">
		<FormattedHTMLMessage id={label} />
		{(label2) ? <p><FormattedHTMLMessage id={label2} /></p> : null}
	</div>
	;

export default BusinessPlanSubSectionTitle;
